module.exports = __webpack_public_path__ + "static/media/new-message-correct.21bd1fc9.png";